// ====================================
// FICHIER DE CONFIGURATION ÉDITABLE
// Modifiez ce fichier pour mettre à jour tout le contenu du site
// ====================================

export const siteConfig = {
  businessName: "Le Rosebif",
  tagline: "Jardinier à domicile à Coëx et alentours",
  ownerName: "Mr Ingram",
  
  // COORDONNÉES
  contact: {
    phone: "07 82 58 66 85",
    whatsapp: "33782586685",
    email: "hassaningram@gmail.com",
    facebook: "https://www.facebook.com/lerosebif",
    address: "Coëx, Vendée (85220)",
    siret: "813 136 249 00030",
    sapAgreement: "SAP813136249",
    insurance: "Assurance RC Pro",
    hours: "Lun, Mar, Jeu, Ven : 11h–17h | Fermé Mer, Sam, Dim",
    hoursDetail: "Je suis disponible les lundis, mardis, jeudis et vendredis, de 11h à 17h. Fermé le mercredi, le samedi et le dimanche. Le matin, j'entretiens une résidence privée à Brétignolles-sur-Mer."
  },

  // ZONE D'INTERVENTION - Vendée (30km autour de Coëx)
  serviceArea: {
    mainCity: "Coëx",
    region: "Vendée",
    department: "85",
    radius: "30 km autour de Coëx",
    // Cities with their coordinates for map markers - VERIFIED FROM WIKIPEDIA & MAPPING SOURCES
    // Updated Feb 2026 with high-precision coordinates
    citiesWithCoords: {
      "Coëx": { lat: 46.6981, lng: -1.7597 },  // High precision from latitude.to & mongabay
      "La Chapelle-Hermier": { lat: 46.6829, lng: -1.7227 },
      "Saint-Révérend": { lat: 46.6989, lng: -1.8306 },
      "L'Aiguillon-sur-Vie": { lat: 46.6700, lng: -1.8300 },
      "Apremont": { lat: 46.7508, lng: -1.7397 },
      "Martinet": { lat: 46.6775, lng: -1.6781 },
      "Saint-Maixent-sur-Vie": { lat: 46.7333, lng: -1.8333 },
      "La Chaize-Giraud": { lat: 46.6500, lng: -1.8333 },
      "Landevieille": { lat: 46.6397, lng: -1.8058 },  // High precision from france-voyage & maptons
      "Saint-Julien-des-Landes": { lat: 46.6417, lng: -1.7117 },
      "Maché": { lat: 46.7550, lng: -1.6860 },
      "Commequiers": { lat: 46.7613, lng: -1.8359 },
      "Givrand": { lat: 46.6667, lng: -1.9000 },
      "Brétignolles-sur-Mer": { lat: 46.6333, lng: -1.8667 },
      "Vairé": { lat: 46.6025, lng: -1.7547 },
      "Le Fenouiller": { lat: 46.7170, lng: -1.9170 },
      "Les Achards": { lat: 46.6203, lng: -1.6578 },
      "Beaulieu-sous-la-Roche": { lat: 46.6778, lng: -1.6089 },
      "Brem-sur-Mer": { lat: 46.6058, lng: -1.8303 },
      "Saint-Gilles-Croix-de-Vie": { lat: 46.6947, lng: -1.9294 },
      "Saint-Hilaire-de-Riez": { lat: 46.7220, lng: -1.9440 },
      "Challans": { lat: 46.8500, lng: -1.8833 },
      "Aizenay": { lat: 46.7333, lng: -1.6167 },
      "La Roche-sur-Yon": { lat: 46.6667, lng: -1.4333 },
      "Notre-Dame-de-Riez": { lat: 46.7453, lng: -1.9044 },
      "Le Perrier": { lat: 46.8192, lng: -1.9936 },
      "Soullans": { lat: 46.7967, lng: -1.8986 },
      "La Garnache": { lat: 46.8914, lng: -1.8306 },
      "Palluau": { lat: 46.8000, lng: -1.6200 },
      "La Mothe-Achard": { lat: 46.6194, lng: -1.6578 },
      "Nieul-le-Dolent": { lat: 46.5740, lng: -1.5090 }
    },
    cities: [
      // Proche (0-10km)
      "Coëx", "La Chapelle-Hermier", "Saint-Révérend", "L'Aiguillon-sur-Vie", 
      "Apremont", "Martinet", "Saint-Maixent-sur-Vie", "La Chaize-Giraud",
      "Landevieille", "Saint-Julien-des-Landes", "Maché",
      // Intermédiaire (10-20km)
      "Commequiers", "Givrand", "Brétignolles-sur-Mer", "Vairé", 
      "Le Fenouiller", "Les Achards", "Beaulieu-sous-la-Roche", 
      "Brem-sur-Mer", "Saint-Gilles-Croix-de-Vie",
      // Plus loin (20-30km)
      "Saint-Hilaire-de-Riez", "Challans", "Aizenay", "La Roche-sur-Yon",
      "Notre-Dame-de-Riez", "Le Perrier", "Soullans", "La Garnache",
      "Palluau", "La Mothe-Achard", "Nieul-le-Dolent"
    ]
  },

  // TARIFS (TTC)
  pricing: {
    tonte: {
      title: "Tonte de pelouse",
      price: "0,28 €/m²",
      priceAfterCredit: "0,14 €/m²",
      details: "Pelouse entretenue ≤ 1 000 m²",
      includes: ["Tonte complète", "Coupe-bordures", "Soufflage et finitions"],
      excludes: ["Évacuation déchets verts (supplément)"]
    },
    debroussaillage: {
      title: "Débroussaillage / Fauchage",
      price: "0,75 €/m²",
      priceAfterCredit: "0,375 €/m²",
      details: "Terrain non entretenu ou à remettre en état",
      includes: ["Fauchage complet", "Débroussaillage", "Ramassage grossier"],
      excludes: ["Évacuation déchets (supplément)"]
    },
    haies: {
      title: "Taille de haies",
      options: [
        { height: "≤ 1,5 m", price: "5 €/m", priceAfterCredit: "2,50 €/m" },
        { height: "1,5 - 2,5 m", price: "7,50 €/m", priceAfterCredit: "3,75 €/m" },
        { height: "> 2,5 m", price: "12 €/m", priceAfterCredit: "6 €/m" }
      ],
      details: "Taille 2 faces + dessus",
      includes: ["Taille soignée", "Ramassage des branches"],
      excludes: ["Évacuation déchets (supplément)"]
    },
    dechets: {
      title: "Évacuation déchets verts",
      price: "15 € / trajet",
      priceAfterCredit: "7,50 €",
      details: "Environ 1 000 litres par trajet"
    },
    vigilance: {
      title: "Vigilance résidence secondaire",
      price: "30 € / passage",
      priceAfterCredit: "15 €",
      includes: ["Vérification complète", "Photos envoyées", "Arrosage si besoin", "Relevé courrier"]
    },
    bricolage: {
      title: "Petit bricolage SAP",
      price: "45 €/heure",
      priceAfterCredit: "22,50 €/heure",
      details: "Interventions ≤ 2 heures (conformité SAP)",
      examples: ["Montage meuble", "Fixation étagère", "Petit entretien"],
      excludes: ["Plomberie", "Électricité", "Chauffage/gaz"]
    }
  },

  // SERVICES - Enhanced content for SEO (600+ words per service)
  services: [
    {
      id: "tonte",
      title: "Tonte de pelouse",
      subtitle: "Pelouse impeccable, toute l'année",
      description: "Tonte régulière ou ponctuelle de votre gazon avec finitions soignées. Matériel professionnel pour un résultat impeccable.",
      icon: "Scissors",
      longDescription: `La tonte de pelouse est le service de jardinage le plus demandé en Vendée, et pour cause : un gazon bien entretenu est la base d'un jardin agréable à vivre. En tant que jardinier professionnel basé à Coëx, je propose un service de tonte complet et soigné, adapté aux spécificités du climat vendéen.

**Pourquoi faire appel à un professionnel pour la tonte ?**

Tondre sa pelouse peut sembler simple, mais obtenir un résultat vraiment professionnel demande du savoir-faire. La hauteur de coupe doit être adaptée à la saison : plus haute en été pour protéger les racines de la chaleur, plus courte au printemps pour favoriser la densité. En Vendée, le climat océanique implique une croissance soutenue de mars à novembre, nécessitant des tontes régulières.

**Mon approche de la tonte**

J'interviens avec du matériel professionnel : tondeuse autoportée pour les grandes surfaces, tondeuse rotative pour les zones classiques, et coupe-bordures pour les finitions le long des massifs, allées et clôtures. Chaque tonte inclut :
- Le ramassage des feuilles et débris avant passage
- La tonte à la hauteur adaptée à la saison
- Les finitions au coupe-bordures
- Le soufflage des allées et terrasses

**Fréquence recommandée**

Pour une pelouse en parfait état, je recommande une tonte toutes les 1 à 2 semaines de mars à octobre. En période de forte croissance (avril-juin), une tonte hebdomadaire est idéale. Je propose des forfaits réguliers qui vous garantissent un jardin toujours impeccable sans avoir à y penser.

**Zones d'intervention**

J'interviens à Coëx et dans toutes les communes environnantes : Saint-Gilles-Croix-de-Vie, Challans, Brétignolles-sur-Mer, Aizenay, Les Achards, et bien d'autres. Le rayon d'intervention s'étend sur 30 km autour de Coëx.

**Tarification transparente**

Le tarif de 0,28€/m² TTC (soit environ 0,14€/m² après crédit d'impôt) s'applique aux pelouses entretenues jusqu'à 1 000 m². Pour les plus grandes surfaces ou les terrains en friche, un devis personnalisé est établi gratuitement.`,
      benefits: [
        "Matériel professionnel adapté à chaque terrain",
        "Finitions soignées (bordures, soufflage)",
        "Hauteur de coupe adaptée à la saison",
        "Forfaits réguliers disponibles",
        "Crédit d'impôt 50% applicable"
      ],
      seasonalTips: "En été, maintenez une hauteur de coupe de 7-8 cm pour protéger les racines. Au printemps, descendez progressivement à 4-5 cm pour favoriser la densité."
    },
    {
      id: "debroussaillage",
      title: "Débroussaillage & remise en état",
      subtitle: "Terrain envahi ? Je m'en occupe",
      description: "Remise en état de terrains non entretenus, fauchage de grandes surfaces, débroussaillage complet.",
      icon: "Axe",
      longDescription: `Le débroussaillage est une intervention essentielle pour remettre en état un terrain laissé à l'abandon ou simplement pour maîtriser la végétation sauvage. En Vendée, avec le climat océanique vendéen favorable à la croissance végétale, un terrain peut rapidement être envahi par les ronces, herbes hautes et broussailles.

**Qu'est-ce que le débroussaillage professionnel ?**

Le débroussaillage consiste à éliminer la végétation indésirable qui a colonisé un terrain : ronces, orties, herbes hautes (parfois plus d'un mètre), rejets d'arbres, et toute végétation dense. C'est un travail physique qui nécessite du matériel adapté et une bonne connaissance des techniques de coupe.

**Mes équipements de débroussaillage**

Pour garantir un travail efficace et propre, j'utilise :
- Débroussailleuse professionnelle à lame et à fil
- Faucheuse pour les grandes surfaces planes
- Tronçonneuse pour les repousses ligneuses
- Broyeur pour réduire le volume des déchets

**Types d'interventions**

Je réalise différents types de débroussaillage :
- **Remise en état complète** : terrain non entretenu depuis plusieurs années
- **Débroussaillage préventif** : nettoyage annuel des zones à risque incendie
- **Fauchage de prairie** : entretien de grandes surfaces enherbées
- **Nettoyage de sous-bois** : dégagement de parcelles boisées

**L'obligation légale de débroussaillage**

En zone à risque incendie, le débroussaillage peut être obligatoire dans un rayon de 50 mètres autour des habitations. En Vendée, bien que le risque soit modéré, l'entretien régulier des terrains reste recommandé pour la sécurité et l'esthétique.

**Après le débroussaillage**

Une fois le terrain remis en état, je peux vous proposer un programme d'entretien régulier pour éviter que la végétation ne reprenne le dessus. Un passage de fauchage annuel ou semestriel suffit généralement à maintenir un terrain propre.

**Gestion des déchets verts**

L'évacuation des déchets de débroussaillage est proposée en option (15€/trajet). Les végétaux sont acheminés vers une déchèterie agréée. Pour les très gros volumes, un broyage sur place peut être envisagé.`,
      benefits: [
        "Matériel professionnel puissant",
        "Intervention sur tous types de terrains",
        "Évacuation des déchets en option",
        "Conseils d'entretien post-intervention",
        "Devis gratuit sur site"
      ],
      seasonalTips: "Le débroussaillage est idéal en fin d'hiver (février-mars) avant la reprise de végétation, ou en fin d'été (septembre-octobre) après les fortes chaleurs."
    },
    {
      id: "haies",
      title: "Taille de haies",
      subtitle: "Haies nettes et soignées",
      description: "Taille précise de vos haies, arbustes et topiaires. Travail soigné pour un jardin structuré.",
      icon: "Fence",
      longDescription: `La taille de haies est un art qui demande précision et régularité. En Vendée, les haies sont omniprésentes : elles délimitent les propriétés, protègent du vent océanique et offrent une intimité appréciable. Leur entretien régulier est essentiel pour maintenir un aspect soigné et favoriser leur santé.

**Pourquoi tailler régulièrement vos haies ?**

Une haie non taillée devient rapidement disgracieuse : elle s'élargit, se dégarnit à la base, et peut même empiéter sur la voie publique ou chez le voisin. La taille régulière permet de :
- Maintenir une forme dense et compacte
- Favoriser la ramification et éviter le dégarnissage
- Limiter la hauteur pour faciliter l'entretien futur
- Respecter les limites de propriété

**Mes techniques de taille**

J'adapte ma technique à chaque type de haie :
- **Haies persistantes** (thuya, laurier, troène) : taille géométrique pour un aspect net
- **Haies champêtres** (charme, hêtre) : taille plus souple respectant le port naturel
- **Haies fleuries** (photinia, forsythia) : taille adaptée au cycle de floraison
- **Haies bocagères** : taille de formation ou d'entretien

**Matériel professionnel**

Pour garantir une coupe nette sans abîmer les végétaux, j'utilise :
- Taille-haie thermique professionnel pour les grandes longueurs
- Taille-haie sur perche pour les hauteurs (jusqu'à 4 mètres)
- Cisailles pour les finitions de précision
- Sécateur pour les branches plus épaisses

**Périodes de taille recommandées**

En Vendée, la taille des haies s'effectue généralement :
- **Taille de printemps** (avril-mai) : après les gelées, avant la nidification
- **Taille d'été** (fin août-septembre) : pour une haie nette tout l'automne
- **Attention** : éviter de tailler pendant la période de nidification (mi-mars à fin juillet) si des oiseaux sont présents

**Tarification claire et dégressive**

Mes tarifs sont calculés au mètre linéaire et varient selon la hauteur :
- Haies ≤ 1,5 m : 5€/m TTC (2,50€ après crédit d'impôt)
- Haies 1,5 - 2,5 m : 7,50€/m TTC (3,75€ après crédit d'impôt)
- Haies > 2,5 m : 12€/m TTC (6€ après crédit d'impôt)

Ces tarifs incluent la taille sur les deux faces et le dessus, ainsi que le ramassage grossier des branches.`,
      benefits: [
        "Taille précise et homogène",
        "Matériel adapté à chaque hauteur",
        "Respect des périodes de nidification",
        "Ramassage des branches inclus",
        "Conseils d'entretien personnalisés"
      ],
      seasonalTips: "Taillez vos haies persistantes 2 fois par an (mai et septembre). Pour les haies à floraison printanière, attendez la fin de floraison avant de tailler."
    },
    {
      id: "desherbage",
      title: "Désherbage & finitions",
      subtitle: "Les petits détails qui font la différence",
      description: "Désherbage manuel, nettoyage des massifs, finitions et entretien courant de votre jardin.",
      icon: "Sprout",
      longDescription: `Le désherbage et les finitions sont souvent négligés, pourtant ce sont eux qui font la différence entre un jardin correct et un jardin vraiment soigné. En tant que jardinier professionnel en Vendée, je propose un service complet de désherbage et d'entretien des espaces verts.

**Le désherbage manuel : une méthode durable**

Je pratique exclusivement le désherbage manuel et mécanique, sans utilisation de produits chimiques. Cette approche est :
- **Respectueuse de l'environnement** : pas de pollution des sols et des nappes
- **Durable** : l'arrachage des racines limite la repousse
- **Conforme à la réglementation** : les pesticides sont interdits pour les particuliers depuis 2019

**Mes interventions de désherbage**

Je désherbe tous les espaces de votre jardin :
- **Massifs et parterres** : autour des plantes, arbustes et rosiers
- **Allées et terrasses** : entre les dalles, pavés et graviers
- **Pieds de murs et clôtures** : zones souvent envahies
- **Potagers** : entre les rangs de légumes

**Les finitions qui font la différence**

Au-delà du désherbage, je réalise les petites tâches qui subliment votre jardin :
- Délimitation nette des massifs avec un dresse-bordure
- Binage et aération du sol au pied des plantes
- Paillage pour limiter la repousse des adventices
- Nettoyage des feuilles mortes
- Ramassage des fruits tombés
- Soufflage des allées et terrasses

**Fréquence d'entretien recommandée**

Pour un jardin toujours impeccable, je recommande un passage de finitions :
- **Toutes les 2 à 4 semaines** pendant la belle saison (avril-octobre)
- **Mensuel** en période calme (novembre-mars)

Je propose des forfaits d'entretien régulier qui incluent le désherbage et les finitions, pour un jardin beau toute l'année sans effort de votre part.

**Une approche préventive**

Le meilleur désherbage est celui qu'on n'a pas à faire ! Je vous conseille sur les techniques de paillage, les couvre-sols et les aménagements qui limitent naturellement la pousse des mauvaises herbes.`,
      benefits: [
        "Désherbage 100% manuel et écologique",
        "Finitions soignées (bordures, soufflage)",
        "Forfaits d'entretien régulier",
        "Conseils en prévention",
        "Respect de vos plantations"
      ],
      seasonalTips: "Le printemps (mars-mai) est la période critique pour le désherbage : les adventices poussent vite et n'ont pas encore produit de graines. Un bon désherbage à cette période limite les problèmes pour toute l'année."
    },
    {
      id: "vigilance",
      title: "Vigilance résidence secondaire",
      subtitle: "Partez l'esprit tranquille",
      description: "Surveillance régulière de votre propriété en votre absence avec photos et compte-rendu.",
      icon: "Home",
      longDescription: `La Vendée est une terre de résidences secondaires, particulièrement sur le littoral et dans les communes rurales attractives. Posséder une maison de vacances est un plaisir, mais l'absence prolongée peut être source d'inquiétude. Mon service de vigilance résidence secondaire vous permet de partir l'esprit tranquille.

**En quoi consiste la vigilance ?**

À chaque passage, je réalise une inspection complète de votre propriété :
- **Vérification extérieure** : état du jardin, des clôtures, des volets, de la toiture visible
- **Vérification intérieure** (si accès confié) : absence de fuite, d'intrusion, d'humidité
- **Relevé du courrier** et mise en sécurité
- **Arrosage** des plantes intérieures et extérieures si nécessaire
- **Aération** de la maison pour éviter l'humidité
- **Photos** de l'état général envoyées par email ou SMS

**Pourquoi ce service est essentiel ?**

Une maison inhabitée est vulnérable :
- Les petits problèmes deviennent gros s'ils ne sont pas détectés (fuite d'eau, tuile envolée)
- L'absence visible attire les cambrioleurs
- Le jardin laissé à l'abandon donne une impression de maison abandonnée
- L'humidité s'installe dans une maison non aérée

**Ma présence régulière**

Ma présence régulière sur votre propriété :
- Simule une occupation (volets ouverts/fermés, courrier relevé)
- Permet une détection précoce des problèmes
- Entretient le jardin pour qu'il soit accueillant à votre retour
- Vous rassure grâce aux comptes-rendus photo

**Formules disponibles**

Je propose des formules adaptées à vos besoins :
- **Passage ponctuel** : 30€ TTC (15€ après crédit d'impôt)
- **Forfait mensuel** : passages hebdomadaires à tarif préférentiel
- **Forfait annuel** : solution complète pour les absences prolongées

Chaque formule peut être combinée avec l'entretien du jardin pour une prise en charge globale de votre propriété.

**Zone d'intervention**

J'assure la vigilance des résidences secondaires dans tout le secteur de Coëx et jusqu'à 30 km : Saint-Gilles-Croix-de-Vie, Brétignolles-sur-Mer, Challans, et toutes les communes environnantes.`,
      benefits: [
        "Inspection complète à chaque passage",
        "Photos et compte-rendu détaillé",
        "Relevé du courrier",
        "Arrosage et aération possibles",
        "Détection précoce des problèmes"
      ],
      seasonalTips: "En hiver, vérifiez que le chauffage hors-gel fonctionne et que les canalisations sont protégées. En été, un arrosage régulier du jardin maintient l'aspect accueillant de la propriété."
    },
    {
      id: "bricolage",
      title: "Petit bricolage SAP",
      subtitle: "Les petits travaux du quotidien",
      description: "Interventions courtes (≤2h) pour vos petits travaux : montage, fixation, entretien léger.",
      icon: "Wrench",
      longDescription: `Le petit bricolage fait partie des services à la personne éligibles au crédit d'impôt de 50%, à condition de respecter certaines règles. Je propose des interventions de bricolage courant pour vous faciliter le quotidien, dans le strict respect du cadre réglementaire.

**Qu'est-ce que le petit bricolage SAP ?**

Le Service à la Personne (SAP) autorise les "petits travaux de bricolage dits hommes toutes mains". Ces interventions doivent être :
- **Courtes** : 2 heures maximum par intervention
- **Occasionnelles** : pas de travaux récurrents de type professionnel
- **Non spécialisées** : pas de plomberie, électricité, chauffage

**Exemples de travaux réalisés**

Je peux vous aider pour :
- **Montage de meubles** : étagères, armoires, tables, lits
- **Fixations murales** : tableaux, miroirs, tringles à rideaux, étagères
- **Petits travaux** : changement de poignée, ajustement de porte, pose de plinthe
- **Entretien léger** : graissage de gonds, débouchage simple, changement d'ampoule en hauteur
- **Jardinage connexe** : montage d'abri de jardin (kit), installation de mobilier de jardin

**Ce qui n'est PAS inclus**

Pour respecter la réglementation SAP, je ne réalise pas :
- Travaux de plomberie (même simples)
- Travaux d'électricité (même changement de prise)
- Travaux sur les installations de chauffage/gaz
- Interventions de plus de 2 heures
- Travaux nécessitant des qualifications spécifiques

**Pourquoi cette limite de 2 heures ?**

La limite de 2 heures par intervention est imposée par la réglementation des Services à la Personne. Elle garantit qu'il s'agit bien de "petit bricolage" et non de travaux professionnels déguisés. Si votre projet nécessite plus de temps, il faudra le répartir sur plusieurs interventions.

**Tarification**

Le tarif est de 45€ TTC de l'heure, soit environ 22,50€ après crédit d'impôt de 50%. Le temps de déplacement n'est pas facturé pour les interventions dans le rayon de 30 km autour de Coëx.

**Paiement et facturation**

Comme pour tous mes services, vous pouvez régler par virement bancaire ou par chèque. Une facture détaillée vous est remise pour votre déclaration d'impôts.`,
      benefits: [
        "Interventions rapides (≤ 2h)",
        "Crédit d'impôt 50% applicable",
        "Déplacement inclus (30 km)",
        "Facture pour déclaration fiscale",
        "Travail soigné et propre"
      ],
      seasonalTips: "Profitez de l'hiver pour les petits travaux d'intérieur (montage, fixations) et réservez le printemps pour les installations extérieures (mobilier de jardin, abri)."
    },
    {
      id: "mixte",
      title: "Entretien mixte",
      subtitle: "Plusieurs prestations en une seule visite",
      description: "Combinaison de tonte, taille de haies, désherbage et nettoyage en une intervention groupée pour gagner du temps et économiser sur les déplacements.",
      icon: "Sparkles",
      longDescription: "L'entretien mixte regroupe plusieurs prestations (tonte, taille, désherbage, nettoyage) dans une même visite. Idéal pour les jardins qui demandent plusieurs interventions complémentaires en début ou fin de saison, ou pour les résidences secondaires où l'on souhaite tout faire en une journée.",
      benefits: [
        "Une seule visite pour plusieurs prestations",
        "Économies sur le déplacement",
        "Planning simplifié",
        "Idéal pour résidences secondaires",
        "Crédit d'impôt 50 % applicable"
      ],
      seasonalTips: "Particulièrement utile au printemps (réveil du jardin) et à l'automne (préparation avant l'hiver)."
    },
    {
      id: "remise-en-etat",
      title: "Remise en état jardin",
      subtitle: "Retrouvez un jardin propre, même après des mois d'abandon",
      description: "Reprise complète d'un jardin laissé à l'abandon : débroussaillage, taille de rattrapage, désherbage en profondeur, évacuation des déchets.",
      icon: "Axe",
      longDescription: "La remise en état d'un jardin abandonné demande méthode et matériel adapté. Que vous veniez d'acquérir une propriété, que vous repreniez une résidence secondaire après plusieurs mois ou que vous ayez laissé filer la saison, je remets votre jardin à zéro pour repartir sur une base saine.",
      benefits: [
        "Diagnostic complet avant intervention",
        "Matériel professionnel adapté",
        "Évacuation des déchets verts en option",
        "Plan d'entretien post-remise en état",
        "Crédit d'impôt 50 % applicable"
      ],
      seasonalTips: "Idéal en fin d'hiver (février-mars) avant la reprise de végétation, ou en septembre après les fortes chaleurs."
    },
    {
      id: "rafraichissement",
      title: "Rafraîchissement jardin",
      subtitle: "Coup d'éclat avant l'arrivée des invités ou la mise en vente",
      description: "Intervention ponctuelle pour redonner de l'éclat à un jardin entretenu : tonte précise, taille légère, désherbage des massifs, finitions soignées.",
      icon: "Sparkles",
      longDescription: "Le rafraîchissement est une intervention ponctuelle, plus légère qu'une remise en état mais plus complète qu'une simple tonte. Parfait avant l'arrivée d'invités, une fête de famille, une visite immobilière ou simplement pour repartir sur de bonnes bases après quelques semaines de relâchement.",
      benefits: [
        "Résultat visible immédiatement",
        "Intervention rapide (½ à 1 journée)",
        "Idéal avant événement",
        "Tarif maîtrisé",
        "Crédit d'impôt 50 % applicable"
      ],
      seasonalTips: "À programmer 3 à 5 jours avant l'événement pour un rendu optimal."
    },
    {
      id: "plantation",
      title: "Plantation & massifs",
      subtitle: "Plantation et renouvellement dans vos massifs existants",
      description: "Plantation de massifs, vivaces, arbustes et bulbes. Conseil sur les variétés adaptées au climat vendéen et à votre exposition.",
      icon: "Leaf",
      longDescription: "Compléter un massif existant, remplacer des arbustes manquants, installer des vivaces résistantes au sec ou des bulbes pour le printemps : je vous accompagne dans le choix des végétaux adaptés à votre exposition et au sol vendéen, et m'occupe de la plantation soignée.",
      benefits: [
        "Conseil sur les variétés adaptées au climat océanique",
        "Préparation du sol (amendement, paillage)",
        "Plantation soignée et arrosage de reprise",
        "Suivi possible les premières semaines",
        "Crédit d'impôt 50 % sur la main-d'œuvre éligible (hors végétaux, fournitures et création paysagère)"
      ],
      seasonalTips: "Plantation idéale en automne (octobre-novembre) ou au début du printemps (mars-avril) pour favoriser l'enracinement."
    },
    {
      id: "entretien-general",
      title: "Entretien général de jardin",
      subtitle: "Forfait sur mesure pour un jardin toujours impeccable",
      description: "Programme d'entretien régulier combinant tonte, taille, désherbage et soins divers, planifié sur l'année pour ne plus avoir à y penser.",
      icon: "Leaf",
      longDescription: "L'entretien général est mon offre la plus complète : un contrat d'entretien sur mesure qui s'occupe de tout, du printemps à l'automne. Vous bénéficiez d'un planning sur l'année, d'une priorité d'intervention, et d'un seul interlocuteur pour tous vos besoins jardin.",
      benefits: [
        "Planning annuel personnalisé",
        "Priorité sur les interventions urgentes",
        "Réduction de 5 % dès 2 passages planifiés",
        "Photos après chaque passage (résidences secondaires)",
        "Crédit d'impôt 50 % applicable"
      ],
      seasonalTips: "Le démarrage idéal se fait en mars, avec le réveil végétal, pour caler le planning sur la saison."
    }
  ],

  // TÉMOIGNAGES
  testimonials: [
    {
      name: "Marie D.",
      location: "Saint-Gilles-Croix-de-Vie",
      rating: 5,
      text: "Très satisfaite du travail effectué. Ponctuel, soigneux et à l'écoute. Mon jardin n'a jamais été aussi beau !"
    },
    {
      name: "Philippe M.",
      location: "Challans",
      rating: 5,
      text: "Excellent service pour ma résidence secondaire. Les photos envoyées après chaque passage me rassurent complètement."
    },
    {
      name: "Sylvie L.",
      location: "Brétignolles-sur-Mer",
      rating: 5,
      text: "Travail impeccable et tarifs très honnêtes. Le crédit d'impôt fait vraiment la différence. Je recommande !"
    }
  ],

  // EXCLUSIONS SAP (Important pour conformité)
  sapExclusions: [
    "Plomberie",
    "Électricité",
    "Chauffage et gaz",
    "Gros travaux de bâtiment",
    "Élagage à risque (hauteur > 3m)",
    "Déménagement et débarras",
    "Utilisation de produits phytosanitaires interdits",
    "Travaux pour entreprises (SAP = particuliers uniquement)"
  ],

  // ÉVACUATION DÉCHETS VERTS — Zone par défaut (Pays de Saint-Gilles-Croix-de-Vie Agglomération)
  wasteEvacuationZone: {
    towns: [
      "Givrand", "L'Aiguillon-sur-Vie", "Brem-sur-Mer", "Brétignolles-sur-Mer",
      "La Chaize-Giraud", "Coëx", "Commequiers", "Le Fenouiller", "Landevieille",
      "Notre-Dame-de-Riez", "Saint-Gilles-Croix-de-Vie", "Saint-Hilaire-de-Riez",
      "Saint-Maixent-sur-Vie", "Saint-Révérend"
    ],
    note: "L'évacuation des déchets verts (15 € TTC / trajet, ≈ 7,50 € après crédit d'impôt 50 %, environ 1 000 L) est proposée par défaut dans les communes de l'agglomération du Pays de Saint-Gilles-Croix-de-Vie.",
    outsideNote: "En dehors de cette zone, l'évacuation des déchets verts n'est pas proposée par défaut : vous pouvez conserver les déchets sur place (compost) ou les déposer vous-même en déchèterie. Une solution peut être étudiée au cas par cas."
  },

  // SEO
  seo: {
    defaultTitle: "Le Rosebif - Jardinier à domicile à Coëx, Vendée | Service à la Personne",
    defaultDescription: "Jardinier professionnel à Coëx et alentours en Vendée. Tonte, taille de haies, débroussaillage. Service à la Personne déclaré SAP813136249 - Crédit d'impôt 50%. Devis gratuit !"
  },

  // VIDEOS DISABLED - Set to empty array
  videos: [],

  // REFERRAL PROGRAM
  referralProgram: {
    enabled: true,
    parrainage: {
      rewardParrain: "20€ de réduction",
      rewardFilleul: "10% sur la première prestation",
      conditions: "Valable après la première prestation du filleul",
      code: "ROSEBIF-AMI"
    }
  },

  // SEASONAL PRICING
  seasonalPricing: {
    enabled: true,
    currentSeason: "winter",
    promotions: [
      {
        id: "new-year",
        name: "Offre Nouvel An",
        description: "Remise exceptionnelle pour bien commencer l'année",
        discount: 5,
        validUntil: "2026-02-28",
        services: ["tonte", "haies", "debroussaillage"]
      }
    ]
  }
};

// RÉALISATIONS (Photos avant/après - À remplacer par vraies photos)
export const realisations = [
  {
    id: 1,
    title: "Remise en état jardin - Saint-Gilles-Croix-de-Vie",
    service: "Débroussaillage",
    before: "https://images.unsplash.com/photo-1558293842-c0fd3db86157?w=600",
    after: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600",
    description: "Terrain de 500m² remis en état après 2 ans sans entretien"
  },
  {
    id: 2,
    title: "Taille de haies - Challans",
    service: "Taille",
    before: "https://images.unsplash.com/photo-1592419044706-39796d40f98c?w=600",
    after: "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=600",
    description: "35 mètres de haies taillées, finitions soignées"
  },
  {
    id: 3,
    title: "Entretien pelouse - Brétignolles-sur-Mer",
    service: "Tonte",
    before: "https://images.unsplash.com/photo-1600375739416-5a3bb67a44c1?w=600",
    after: "https://images.unsplash.com/photo-1592419044806-5b0e6099c320?w=600",
    description: "Pelouse de 800m² - tonte régulière avec finitions"
  },
  {
    id: 4,
    title: "Jardin résidence secondaire - Saint-Hilaire-de-Riez",
    service: "Vigilance",
    before: "https://images.unsplash.com/photo-1597255535457-db1d6476fad6?w=600",
    after: "https://images.unsplash.com/photo-1591857177580-dc82b9ac4e1e?w=600",
    description: "Entretien mensuel et surveillance pendant absence des propriétaires"
  }
];
